import React, { useEffect,useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loader from '../Components/CommonComponents/Loader';
import Navbarp from '../Components/CommonComponents/Navbarp'
import SideNav from '../Components/CommonComponents/SideNav'
import { BASE_URL } from '../Config/Config';
import { getLogin, getToken, logout } from '../features/Loginuser';
import { DateTime } from 'luxon';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Navigate } from 'react-router-dom';
import DialogModal from '../Components/CommonComponents/DialogModal';
import SmallLoader from '../Components/CommonComponents/SmallLoader';

function CustomerallDetailpage() {
    const token=useSelector(getToken);
    const login = useSelector(getLogin);
    let params = useParams();
    const customer_id=params.customer_id;
    let dispatch=useDispatch();
    const [loading,setLoading]=useState(true);
    const [custdetail,setCustDetail]=useState(true);
    const [show,setShow]=useState(false);
    const [type,setType]=useState("");
    const [message,setMessage]=useState("");
    const [actionLoader,setActionLoader]=useState(false);
    const [statusloader,setStatusLoader]=useState(false);
    const [data,setData]=useState(null)
    var fdata =new FormData();
      fdata.append("customer_id",params.customer_id)
    useEffect(() => {
          fetch(BASE_URL+"getallcustomerdata", {
              method: "POST",
              headers: {
                //'X-XSRF-TOKEN': 'XSRF-TOKEN)',
                    'Accept': 'application/json',
                  "Authorization": "Bearer "+token,
              },
              body:fdata,
              
              })
              
              .then((response) => {
                if (response.status===401){
                  dispatch(logout());
                }else{
                  return response.json()
                }
              })
              //Then with the data from the response in JSON...
              .then((data) => {
                  setLoading(false);
                  setData(data)
                  setCustDetail(data.customerdetail);
              })
            },[setCustDetail])
            
        function updatedata(e){
            e.preventDefault();
            setStatusLoader(true)
            var updatedata =new FormData(e.target);
            updatedata.append("customer_id",e.target.customer_id.value)
            fetch(BASE_URL+"updatecustomerdetail", {
                method: "POST",
                headers: {
                  //'X-XSRF-TOKEN': 'XSRF-TOKEN)',
                      'Accept': 'application/json',
                    "Authorization": "Bearer "+token,
                },
                body:updatedata,
                
                })
                
                .then((response) => {
                  if (response.status===401){
                    dispatch(logout());
                  }else{
                    return response.json()
                  }
                })
                //Then with the data from the response in JSON...
                .then((data) => {
                  setType("status");
                  setShow(true);
                  setMessage(data.message);
                  setActionLoader(false)
                  setStatusLoader(false)
                })
        }
  function modelAction(show){
    setShow(show);
  }
  if(login==null||login==false){
    return  <Navigate to="/" replace={true} />
    }    
  return (
    <>
    <DialogModal 
        show={show} 
        message={message} 
        action={modelAction} 
        id="" 
        type={type}
        actionLoader={actionLoader}
       />
      <div className="container-fluid ps-0 pe-0">
        <div className="row">
          <div>
           <Navbarp />
          </div>
          <div>
            <h3 className='ms-3' style={{'marginTop':'200px'}}>Customer Detail</h3>
            {loading?
            <Loader/>:  
                <div>   
                    <div className='mt-3'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-1">
                                <label className="form-label">Customer Id</label>
                                <input type="number" name="customer_id" className="form-control" defaultValue={custdetail.customer_id}  />
                                <div id="emailHelp" className="form-text">Id of the Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">First Name</label>
                                <input type="text" name="firstname" className="form-control" defaultValue={custdetail.firstname} />
                                <div id="emailHelp" className="form-text">First Name of Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Last Name</label>
                                <input type="text"  name="lastname" className="form-control" defaultValue={custdetail.lastname} />
                                <div className="form-text">Last Name of Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label className="form-label">Mobile</label>
                                <input type="number" name="telephone" className="form-control" defaultValue={custdetail.telephone}  />
                                <div id="emailHelp" className="form-text">Mobile No of the Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Email</label>
                                <input type="email"  name="email" className="form-control" defaultValue={custdetail.email} />
                                <div id="emailHelp" className="form-text">Email of Customer.</div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label className="form-label">Gender</label>
                                <input type="text" className="form-control" defaultValue={custdetail.gender}  />
                                <div id="emailHelp" className="form-text">Gender of the Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">IP</label>
                                <input type="text"   className="form-control" defaultValue={custdetail.ip}  />
                                <div id="emailHelp" className="form-text">IP Address of  Customer.</div>
                            </div>
                           
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Date of Birth</label>
                                <input type="date"  className="form-control" defaultValue={custdetail.dob} />
                                <div className="form-text">Date of Birth of Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Account Created</label>
                                <input type="text"  className="form-control" defaultValue={DateTime.fromSQL(custdetail.date_added).toFormat("yyyy-LL-dd hh:mm a")}  disabled/>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Customer Group</label>
                                <select className="form-select text-right" aria-label="Default select example" name="customer_group_id" defaultValue={custdetail.customer_group_id}>
                                      <option  value="">Select Type</option>
                                      <option value="1">Kisaan</option>
                                      <option value="2">Dairy Owner</option>
                                  </select>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Status</label>
                                <input type="number"  className="form-control" defaultValue={custdetail.status} />
                                <div id="emailHelp" className="form-text">Statues of  Customer.</div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">login Attempts</label>
                                <input type="number"  className="form-control" defaultValue={custdetail.login_attempts}/>
                                <div className="form-text"></div>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Last login</label>
                                <input type="text"  className="form-control" defaultValue={DateTime.fromSQL(custdetail.last_login).toFormat("yyyy-LL-dd hh:mm a")} />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Blocked Upto</label>
                                <input type="date"   className="form-control" defaultValue={DateTime.fromSQL(custdetail.blocked_up_to).toFormat("yyyy-LL-dd")}  />
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-4">
                                <label  className="form-label">Address_1</label>
                                <input type="text"   className="form-control" defaultValue={data.custaddress[0]?.address_1}  />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-4">
                                <label  className="form-label">Address_2</label>
                                <input type="text"  className="form-control" defaultValue={data.custaddress[0]?.address_2} />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Village</label>
                                <input type="text"  className="form-control" defaultValue={data.custaddress[0]?.village}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-4">
                                <label  className="form-label">City</label>
                                <input type="text"   className="form-control" defaultValue={data.custaddress[0]?.city}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-4">
                                <label  className="form-label">State</label>
                                <input type="text"  className="form-control" defaultValue={data.custaddress[0]?.state}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Postcode</label>
                                <input type="number"  className="form-control" defaultValue={data.custaddress[0]?.postcode}/>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-1">
                                <label  className="form-label">Coupon assigned</label>
                                <input type="text"  className="form-control" defaultValue={data.custcoupon}  />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Coupon Utilised</label>
                                <input type="text"   className="form-control" defaultValue={data.custcouponhis} />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Fire Base Token</label>
                                <input type="text"   className="form-control" defaultValue={data.custfcmtok}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Gestation Entries</label>
                                <input type="text"  className="form-control" defaultValue={data.custgestation}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">IP</label>
                                <input type="text"   className="form-control" defaultValue={data.custip}/>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Milk Entries</label>
                                <input type="text"  className="form-control" defaultValue={data.milkentry}  />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Personal Milk dairy Entries</label>
                                <input type="text"   className="form-control" defaultValue={data.custmilkdairy} />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Product Added</label>
                                <input type="text"   className="form-control" defaultValue={data.dairyprod}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-3">
                                <label  className="form-label">Product entries</label>
                                <input type="text"  className="form-control" defaultValue={data.dairycustprodentry}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Product Edit History</label>
                                <input type="text"   className="form-control" defaultValue={data.productQtyhis}/>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className="row align-items-start ">
                        <div className="ms-3 mb-3 col-12  col-lg-1">
                                <label  className="form-label">Loan Entries</label>
                                <input type="text"  className="form-control" defaultValue={data.dairycustLoan}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Bill Entries</label>
                                <input type="text"   className="form-control" defaultValue={data.dairycustbill}/>
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-1">
                                <label  className="form-label">Order Placed</label>
                                <input type="text"  className="form-control" defaultValue={data.custorder}  />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Rate List Created</label>
                                <input type="text"   className="form-control" defaultValue={data.dairyratelsit} />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Ratelist to customer</label>
                                <input type="text"   className="form-control" defaultValue={data.dairycustratelist} />
                            </div>    
                            <div className="ms-3 mb-3 col-12  col-lg-1">
                                <label  className="form-label">Refferal</label>
                                <input type="text"   className="form-control" defaultValue={data.custrefferal} />
                            </div>
                            <div className="ms-3 mb-3 col-12  col-lg-2">
                                <label  className="form-label">Subscription</label>
                                <input type="text"   className="form-control" defaultValue={data.custsubscrip}/>
                            </div>
                        </div>
                    </div>
                </div>} 
          </div> 
        </div>
      </div>
  </>
  )
}

export default CustomerallDetailpage